export const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://127.0.0.1:8000';
